import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[template-content]'
})
export class ContentDirective {
    constructor(public tpl: TemplateRef<any>) { }

}
